export type MaintenanceBannerType = 'attention' | 'critical';

export interface MaintenanceBannerNotice {
  type: MaintenanceBannerType;
  eyebrow: string;
  title: string;
  message: string;
  window: string;
  /** When true the user can close it; it stays hidden for the browser session only. */
  dismissible: boolean;
  /** Inclusive start (ISO-8601 with offset). Omit to show from deployment. */
  startsAt?: string;
  /** Exclusive end (ISO-8601 with offset). */
  endsAt: string;
}

const WINDOW_LABEL = 'Fri, Oct 30, 10:00 PM CT - Sat, Oct 31, 6:00 PM CT';
// CDT (UTC-5): DST in the US ends on Nov 1, 2026.
const WINDOW_START = '2026-10-30T22:00:00-05:00';
const WINDOW_END = '2026-10-31T18:00:00-05:00';

export const MAINTENANCE_BANNERS: MaintenanceBannerNotice[] = [
  {
    type: 'attention',
    eyebrow: 'Scheduled maintenance',
    title: 'EDP scheduled maintenance is coming up',
    message:
      'EDP maintenance will run from Friday, Oct 30 at 10:00 PM CT through Saturday, Oct 31 at 6:00 PM CT. ' +
      'MIQ may be unavailable or have limited functionality during this time. Please save your work beforehand.',
    window: WINDOW_LABEL,
    dismissible: true,
    endsAt: WINDOW_START,
  },
  {
    type: 'critical',
    eyebrow: 'Maintenance in progress',
    title: 'EDP scheduled maintenance is in progress',
    message:
      'MIQ may show outdated data or respond slowly. Please refrain from using MIQ until maintenance ends ' +
      'on Saturday, Oct 31 at 6:00 PM CT. Thank you for your understanding.',
    window: WINDOW_LABEL,
    dismissible: false,
    startsAt: WINDOW_START,
    endsAt: WINDOW_END,
  },
];
